import { Component } from "@angular/core";

@Component({
  selector: "icon-compensacion-mujeres-chart-orientacion-abajo",
  templateUrl: "./compensacion-mujeres-chart-orientacion-abajo.svg",
  styles: [`
    :host {
      display: block;
      width: 100%;
      height: 100%;
    }

    svg {
      display: block;
      width: 100%;
      height: 100%;
    }
  `],
  standalone: true,
})
export class CompensacionMujeresChartOrientacionAbajoComponent {}
